/* Rolmmobau before/after slider */
( function () {
	function init( root ) {
		var slider = root.querySelector( '.rm-ba__slider' );
		var range = root.querySelector( '.rm-ba__range' );
		if ( ! slider || ! range ) return;
		function apply() { slider.style.setProperty( '--rm-ba-pos', range.value + '%' ); }
		range.addEventListener( 'input', apply );
		apply();
	}
	document.addEventListener( 'DOMContentLoaded', function () {
		document.querySelectorAll( '.rm-ba' ).forEach( init );
	} );
} )();
